/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React from "react";
import {
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  Table as MuiTable,
  Box,
  TableBody,
} from "@mui/material";
import PropTypes from "prop-types";
import Typography from "../../../../../components/common/new/Typography/Typography";
import style from "./FriendSummaryReportTable.styles";

const BLOCK = "BLOCK";
function Table({
  checkAllToggle,
  columns,
  rows,
  scrollable,
  columnCellStyle,
  headCellStyle,
  hasAction = false,
  searchData,
}) {
  return (
    <TableContainer
      style={{
        ...style.container,
        ...{ overflow: scrollable ? "auto" : "hidden" },
      }}
    >
      <MuiTable aria-label="collapsible table" stickyHeader>
        <TableHead sx={{ paddingTop: "1.4rem" }}>
          <TableRow sx={{ padding: "1rem" }}>
            <TableCell
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            />
            <TableCell
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            />
            <TableCell
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            />
            <TableCell
              align="right"
              colSpan={3}
              sx={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  YMD
                </Box>
              </Typography>
            </TableCell>
            <TableCell
              align="right"
              colSpan={3}
              sx={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  YWD
                </Box>
              </Typography>
            </TableCell>
            <TableCell
              align="right"
              colSpan={4}
              sx={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  FDB
                </Box>
              </Typography>
            </TableCell>
            <TableCell
              align="right"
              colSpan={4}
              sx={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                    borderRight: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  FDG
                </Box>
              </Typography>
            </TableCell>
            <TableCell
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            />
          </TableRow>
          <TableRow sx={{ padding: "1rem" }}>
            {columns?.map((col, index) => {
              const Component = col.key === "checkBox" ? col.displayName : null;
              return (
                <TableCell
                  key={col.displayName}
                  align="left"
                  rowSpan={col.rowspan ? col.rowSpan : 1}
                  colSpan={col.colSpan ? col.colSpan : 1}
                  style={{ ...style.tableHeadCell, ...columnCellStyle }}
                >
                  <Box
                    sx={{
                      borderRight:
                        index !== columns.length - 1
                          ? "1px solid rgba(94, 94, 94, 1)"
                          : "",
                      paddingRight: "0.6rem",
                    }}
                  >
                    <Typography
                      variant="small"
                      weight={600}
                      style={headCellStyle}
                      sx={{ color: "#000000" }}
                    >
                      {Component ? (
                        <Component
                          sx={{ padding: "3px 14.8px" }}
                          onChange={(e) => checkAllToggle(e.target.checked)}
                        />
                      ) : (
                        col.displayName
                      )}
                    </Typography>
                  </Box>
                </TableCell>
              );
            })}
            {hasAction ? <TableCell sx={style.tableHeadCell} /> : null}
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            ...style.tableBody,
            "& .MuiTypography-root": {
              fontSize: "14px",
              color: "#000000",
            },
            "tr:nth-child(even)": {
              backgroundColor: "#E8EDF4",
            },
          }}
        >
          {rows}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}
const propTypes = {
  checkAllToggle: PropTypes.fun,
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
  hasAction: PropTypes.bool,
  columnCellStyle: PropTypes.arrayOf(PropTypes.objectOf()),
  scrollable: PropTypes.bool,
  headCellStyle: PropTypes.objectOf(),
  searchData: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
};
const defaultProps = {
  hasAction: false,
  scrollable: false,
  columnCellStyle: {},
  headCellStyle: {},
  checkAllToggle: () => {},
};
Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
export default Table;
